import { TColors } from '@cian/ui-kit-design-tokens/colors';

import { ELabelType } from '../types/newbuildingHeader';

export const BACKGROUND_COLOR: Record<ELabelType, TColors> = {
  [ELabelType.Reliable]: 'control-positive-secondary-default',
  [ELabelType.Problem]: 'accent-negative-primary',
  [ELabelType.SalesLeader]: 'overlay-control-dark',
};

export const TEXT_COLOR: Record<ELabelType, TColors> = {
  [ELabelType.Reliable]: 'text-positive-pressed',
  [ELabelType.Problem]: 'decorative-theme-white',
  [ELabelType.SalesLeader]: 'decorative-theme-dark',
};

export const ICON = {
  [ELabelType.Reliable]: undefined,
  [ELabelType.Problem]: undefined,
  [ELabelType.SalesLeader]: undefined,
};
